module.exports = __webpack_public_path__ + "img/1.3256ad38.jpg";